export default __webpack_public_path__ + "b187ae583d83cd2c4414e14c16d9eee0.png";